import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-busqueda',
  templateUrl: './modal-busqueda.component.html',
  styleUrls: ['./modal-busqueda.component.scss']
})
export class ModalBusquedaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  busqueda(termino: string) {
    window.location.href = 'https://www.guanajuato.gob.mx/resultados-busqueda.php?buscar=' + termino;
  }

}
